import { TextField } from "@material-ui/core";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import ButtonWithStyle from "../../../HOCs/ButtonWithStyle/ButtonWithStyle";
import TextFieldWithStyle from "../../../HOCs/InputWithStyle/InputWithStyle";

import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

const Discount = ({ onSubmit, menuItems = [], updateMenu, onCancel }) => {
	useEffect(() => {
		updateMenu();
	}, [updateMenu]);

	const { handleSubmit, register } = useForm();

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			<h3>
				Agregar descuento a un platillo. <br /> Revise que la cantidad no sea mayor al valor del producto
			</h3>
			<TextFieldWithStyle
				style={{ maxWidth: "300px" }}
				margin="normal"
				required
				fullWidth
				id="name"
				label="Nombre del Premio"
				name="name"
				autoFocus
				type="text"
				inputRef={register({ required: true, minLength: 2 })}
			/>
			<br />
			<TextFieldWithStyle
				style={{ maxWidth: "300px" }}
				margin="normal"
				fullWidth
				id="amount"
				label="Descuento en Pesos"
				name="amount"
				autoFocus
				type="number"
				inputRef={register({ required: true, minLength: 2 })}
			/>
			<br />
			<TextField
				style={{ width: "300px", margin: 20 }}
				select
				SelectProps={{
					native: true,
					IconComponent: () => <ArrowDropDownIcon />,
				}}
				name="itemDetails"
				inputRef={register({ required: true, minLength: 2 })}
			>
				{menuItems.map((item) => (
					<option key={item._id} value={item._id}>
						{`${item.name} - ${item.price || "??"}$`}
					</option>
				))}
			</TextField>
			<br />
			<ButtonWithStyle onClick={handleSubmit(onSubmit)}>Guardar</ButtonWithStyle>
			<ButtonWithStyle onClick={onCancel}>Cancelar</ButtonWithStyle>
		</form>
	);
};

export default Discount;
